<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">{{ texts.invoices.title }}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ texts.invoices.subTitle }}</div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-card
            v-if="selectedStatus === 0"
            class="card-main mx-4 my-2"
            style="border: 1px solid #c5cdd3; border-radius: 32px; background: rgb(97,163,217); background: linear-gradient(180deg, rgba(97,163,217,1) 0%, rgba(25,61,110,1) 100%);"
            width="348"
            elevation="5"
            height="200"
            outlined
          >
            <v-card-text class="pa-0 pt-3">
              <v-row align="center" class="pt-2 pl-2">
                <v-col cols="9" class="pl-5">
                  <div style="color: #FFFFFF; font-family: montserrat-bold; font-size: 16px;">{{ texts.dashboard.exchangeRateActual }}</div>
                  <div class="content-balance" style="color: #FFFFFF; font-family: montserrat-bold; font-size: 32px;">
                    ${{ formatMoney(items.exchangeRateToday ? (items.exchangeRateToday < 1 ? (1 / items.exchangeRateToday) : items.exchangeRateToday) : 0) }}
                    MXN
                  </div>
                </v-col>
              </v-row>
              <div
                class="pl-4 pt-2 blocked-amount"
                style="position: relative; z-index: 10; padding-right: 120px; color: #FFFFFF; font-family: montserrat-bold; font-size: 12px;"
              >
                {{ texts.dashboard.exchangeRateTodayDescription }} {{ countdownDashboard }}
                {{ texts.dashboard.seconds }}
              </div>
            </v-card-text>
            <div
              style="
                position: absolute;
                top: 0;
                right: 0;
                margin-top: -12px;
                margin-right: -36px;
                background-color: #7ea4c9;
                -webkit-box-shadow: 0px 5px 8px 3px rgba(0,0,0,0.75);
                -moz-box-shadow: 0px 5px 8px 3px rgba(0,0,0,0.75);
                box-shadow: 0px 5px 8px 3px rgba(0,0,0,0.75);
                width: 150px;
                height: 150px;
                border-radius: 100px;
              "
            ></div>
          </v-card>
        </v-col>
        <!-- <v-col class="d-flex justify-end pa-0 my-4">
          <v-card
            v-if="operationType === 'Venta' && selectedStatus === 0 || operationType === 'Compra' && selectedStatus === 1"
            class="card-main mx-4 my-2"
            style="border: 1px solid #c5cdd3; border-radius: 32px;"
            width="348"
            elevation="5"
            height="200"
            outlined
          >
            <v-card-text class="pt-6">
              <v-row align="center">
                <v-col cols="9" class="pl-5">
                  <div class="usd-balance" style="font-family: montserrat-semibold;">{{ texts.dashboard.usdBalance }}</div>
                  <div class="content-balance" style="font-family: montserrat-semibold;">
                    ${{ formatMoney(balanceUsd ? balanceUsd : 0) }} USD
                  </div>
                </v-col>
                <v-col cols="3" class="text-right pr-5">
                  <v-img
                    style="border-radius: 10px;
                    -webkit-box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);
                    -moz-box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);
                    box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);"
                    src="../../assets/images/Flags_usa.svg"
                    alt="usa-flag"
                    width="47"
                    height="35"
                  />
                </v-col>
              </v-row>
              <div class="pl-3 pt-2 blocked-amount" style="font-family: montserrat-semibold;">
                {{ texts.dashboard.blockedAmount }}
                <span class="blocked-amount-2" style="font-family: montserrat-semibold;"
                  >${{ formatMoney(blockedUsd ? blockedUsd : 0) }}</span
                >
              </div>
            </v-card-text>
          </v-card>
          <v-card
            v-if="operationType === 'Compra' && selectedStatus === 0 || operationType === 'Venta' && selectedStatus === 1"
            class="card-main mx-4 my-2"
            style="border: 1px solid #c5cdd3; border-radius: 32px;"
            width="348"
            height="200"
            elevation="5"
            outlined
          >
            <v-card-text class="pt-6">
              <v-row align="center">
                <v-col cols="9" class="pl-5">
                  <div class="usd-balance" style="font-family: montserrat-semibold;">{{ texts.dashboard.mxnBalance }}</div>
                  <div class="content-balance pt-3" style="font-family: montserrat-semibold;">
                    ${{ formatMoney(balanceMxn ? balanceMxn : 0) }} MXN
                  </div>
                </v-col>
                <v-col cols="3" class="text-right pr-5">
                  <v-img
                    style="border-radius: 10px;
                      -webkit-box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);
                      -moz-box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);
                      box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);"
                    src="../../assets/images/Flags_mex.svg"
                    alt="mex-flag"
                    width="47"
                    height="35"
                  />
                </v-col>
              </v-row>
              <div class="pl-3 pt-2 blocked-amount" style="font-family: montserrat-semibold;">
                {{ texts.conversions.assigned + ": " }}
                <span style="font-family: montserrat-semibold;">${{ formatMoney(totalAmountMxn ? totalAmountMxn : 0) }}</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col> -->
      </v-row>
      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col cols="12" md="6">
          <v-tabs v-model="selectedStatus" @change="getInvoices(), selected = []" background-color="transparent" show-arrows>
            <v-tab
              class="global-tab"
              style="font-family: 'montserrat-bold';"
              v-for="item in status"
              :key="item.sStatusId"
              :value="item.sStatusId"
            >
              {{ item.sName }}
            </v-tab>
            <v-tabs-slider></v-tabs-slider>
          </v-tabs>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end pa-0 my-4" style="flex-wrap: wrap;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 my-2"
            style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            @click="openDialogSupplier"
          >
            <v-icon left>mdi-plus</v-icon>
            {{ texts.invoices.addInvoice }}
          </v-btn>
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 my-2"
            style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            @click="dialogSendPay = true, selectedStatus == '1' ? (selectedCurrency = selectedDestCurrency, e1 = 2, openPayNow(selected)) : e1 = 1"
            :disabled="selected.length === 0"
          >
            <v-icon left>mdi-plus</v-icon>
            {{ texts.invoices.pay }}
          </v-btn>
          <v-btn
            color="#0075B8"
            elevation="8"
            style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            class="mr-2 my-2"
            :disabled="selected.length === 0 || baseCurrency == selectedDestCurrency"
            @click="openConvert(selected)"
            v-if="selectedStatus === 0"
          >
            <v-icon left>mdi-plus</v-icon>
            {{ texts.invoices.convert }}
          </v-btn>
          <v-btn
            color="#0075B8" 
            elevation="8" 
            class="white--text my-2"
            style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;" 
            @click="dataXLSX()"
          >
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ texts.suppliers.download }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-4">
        <v-col cols="12" md="6" class="d-flex my-2 py-0">
          <v-autocomplete
            :label="texts.invoices.selectSupplier"
            :items="suppliers"
            hide-details
            style="font-family: 'montserrat-medium'; border-radius: 20px;"
            outlined
            clearable
            class="mr-2"
            item-value="sPaymentRecipientId"
            item-text="sName"
            @change="getInvoices()"
            v-model="selectedSupplier"
          ></v-autocomplete>
          <v-text-field v-model="search" min-width="288" max-width="288" label="Buscar" hide-details style="font-family: 'montserrat-medium'; border-radius: 20px;" append-icon="mdi-magnify" outlined></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="d-flex my-2 justify-end py-0">
          <div class="d-flex align-center" style="width: fit-content; background: #BFD7ED; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15); border-radius: 10px; padding: 15px; border: 1px solid #C5CDD3;">
            <div class="pa-1 mr-3" style="background-color: #ECF6FF; border-radius: 5px;">
              <v-img src="../../assets/icons/trending-up.svg" style="width: 24px;"></v-img>
            </div>
            <div class="mr-1" style="font-family: 'montserrat-semibold';">{{ texts.conversionsHistory.totalCurrencyGain + ": " }}</div>
            <span style="font-family: 'montserrat-bold'" :style="{ color: items.totalProfit < 0 ? '#0075B8' : '#0075B8'}"> 
              {{ " $" + formatMoney(items.totalProfit) + " " + (items.totalProfitCurrency || 'MXN') }}
            </span>
          </div>
        </v-col>
      </v-row>
      <v-data-table class="mt-6 d-none d-sm-block" hide-default-header :search="search" :headers="headersInvoices" :items="invoices" >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th v-if="selectedStatus != '2'" class="header__title left" >{{ texts.invoices.name }}</th>     
              <th class="header__title center">{{ texts.invoices.supplier }}</th>                                                                                                                                                                                    
              <th class="header__title center">{{ texts.invoices.purchaseDate }}</th>                                                                                                                                                                               
              <th class="header__title center">{{ texts.invoices.dueDate }}</th>                                                                                                                                                                       
              <th class="header__title center">{{ texts.invoices.invoice }}</th>                                                                                                                                                                  
              <th class="header__title center">{{ texts.invoices.sId }}</th>                                                                                                                                                                  
              <th class="header__title center">{{ texts.invoices.status }}</th>                                                                                                                                                                 
              <th class="header__title center" v-if="selectedStatus == '1'">{{ texts.invoices.avaible }}</th>                                                                                                                                                                
              <th class="header__title center">{{ texts.invoices.totalAmountMXN }}</th>                                                                                                                                                                  
              <th class="header__title center">{{ texts.invoices.rateProtection }}</th>                                                                                                                                                                    
              <th class="header__title center" style="text-wrap: wrap;">{{ texts.invoices.currencyGain }}</th>                                                                                                                                                              
              <th class="header__title center" style="text-wrap: wrap;">{{ texts.invoices.profitPercentage }}</th>    
              <th class="header__title right">{{ texts.invoices.actions }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item" v-if="selectedStatus != '2'">
                <v-checkbox
                  v-if="selectedStatus == '0'"
                  :input-value="isSelected(item)"
                  @change="toggleSelect(item)"
                  :disabled="item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5' || (selectedDestCurrency !== null && selectedDestCurrency !== item.paymentsRecipent[0].sAccountCurrency)"
                ></v-checkbox>
                <v-checkbox
                  v-else-if="selectedStatus == '1'"
                  :input-value="isSelected(item)"
                  @change="toggleSelect(item)"
                  :disabled="item.invoice_payments_relationship.some(rel => rel.transaction.sStatusId != '5a792637-1103-4a89-8f67-86c49b93e227') || parseFloat(item.dTotalAmount) != item.totalAmount"
                ></v-checkbox>
              </td>
              <td class="table__item">{{ item.sName }}</td>
              <td class="table__item">{{ formatDate(item.dPurchaseDate) }}</td>
              <td class="table__item">{{ formatDate(item.dDueDate) }}</td>
              <td class="table__item">{{ item.sInvoice }}</td>
              <td class="table__item">{{ item.sId }}</td>
              <td class="table__item">
                <v-chip v-if="item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'" class="ma-2" color="primary" outlined>
                  <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                </v-chip>
                <v-chip v-else-if="item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'" class="ma-2" outlined color="green">
                  <h4 style="font-family: 'montserrat-medium';">{{ "Converted" }}</h4>
                </v-chip>
                <v-chip v-else-if="item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'" class="ma-2" outlined color="#193D6E">
                  <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                </v-chip>
              </td>
              <td class="table__item" v-if="selectedStatus == '1'">
                <v-icon v-if="item.invoice_payments_relationship.some(rel => rel.transaction.sStatusId != '5a792637-1103-4a89-8f67-86c49b93e227') || parseFloat(item.dTotalAmount) != item.totalAmount" style="color: grey;">mdi-alert-circle</v-icon>
                <v-icon v-else style="color: green;">mdi-check-circle</v-icon>
              </td>
              <td class="table__item">$ {{ formatMoney(item.dTotalAmount) + " " + item.paymentsRecipent[0].sAccountCurrency }}</td>
              <td class="table__item">$ {{ formatMoney(item.dRateProtection) }} MXN</td>
              <td class="table__item" :style="item.dCurrencyGainMxn >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ item.dCurrencyGainMxn ? ('$ ' + formatMoney(item.dCurrencyGainMxn) + ' ' + (item.profitCurrency || 'MXN')) : "-" }}</td>
              <td class="table__item" :style="item.dProfitPercentage >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</td>
              <td class="table__item">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="editInvoice(item)"
                      :disabled="
                        loading
                      "
                      v-bind="attrs"
                      v-on="on"
                      icon
                      color="black"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar factura</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="openDialogDeleteInvoice(item)"
                      :disabled="
                        loading ||
                        item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                      "
                      v-bind="attrs"
                      v-on="on"
                      icon
                      color="red"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete item</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="invoices">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile" v-if="selectedStatus != '2'">
                <div>{{ texts.invoices.name }}</div>
                <div>
                  <v-checkbox
                    v-if="selectedStatus == '0'"
                    :input-value="isSelected(item)"
                    @change="toggleSelect(item)"
                    :disabled="item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5' || (selectedDestCurrency !== null && selectedDestCurrency !== item.paymentsRecipent[0].sAccountCurrency)"
                  ></v-checkbox>
                  <v-checkbox
                    v-else-if="selectedStatus == '1'"
                    :input-value="isSelected(item)"
                    @change="toggleSelect(item)"
                    :disabled="item.invoice_payments_relationship.some(rel => rel.transaction.sStatusId != '5a792637-1103-4a89-8f67-86c49b93e227') || parseFloat(item.dTotalAmount) != item.totalAmount"
                  ></v-checkbox>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.supplier }}</div>
                <div>{{ item.sName }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.purchaseDate }}</div>
                <div>{{ formatDate(item.dPurchaseDate) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.dueDate }}</div>
                <div>{{ formatDate(item.dDueDate) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.invoice }}</div>
                <div>{{ item.sInvoice }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.sId }}</div>
                <div>{{ item.sId }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.status }}</div>
                <div>
                  <v-chip v-if="item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'" class="ma-2" color="primary" outlined>
                    <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                  </v-chip>
                  <v-chip v-else-if="item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'" class="ma-2" outlined color="green">
                    <h4 style="font-family: 'montserrat-medium';">{{ "Converted" }}</h4>
                  </v-chip>
                  <v-chip v-else-if="item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'" class="ma-2" outlined color="#193D6E">
                    <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile" v-if="selectedStatus == '1'">
                <div>{{ texts.invoices.avaible }}</div>
                <div>
                  <v-icon v-if="item.invoice_payments_relationship.some(rel => rel.transaction.sStatusId != '5a792637-1103-4a89-8f67-86c49b93e227') || parseFloat(item.dTotalAmount) != item.totalAmount" style="color: grey;">mdi-alert-circle</v-icon>
                  <v-icon v-else style="color: green;">mdi-check-circle</v-icon>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.totalAmountMXN }}</div>
                <div>$ {{ formatMoney(item.dTotalAmount) + " " + item.paymentsRecipent[0].sAccountCurrency }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.rateProtection }}</div>
                <div>$ {{ formatMoney(item.dRateProtection) }} MXN</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.currencyGain }}</div>
                <div :style="item.dCurrencyGainMxn >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ item.dCurrencyGainMxn ? ('$ ' + formatMoney(item.dCurrencyGainMxn) + ' ' + (item.profitCurrency || 'MXN')) : "-" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.invoices.profitPercentage }}</div>
                <div :style="item.dProfitPercentage >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.actions }}</div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="editInvoice(item)"
                        :disabled="
                          loading
                        "
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="black"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar factura</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openDialogDeleteInvoice(item)"
                        :disabled="
                          loading ||
                          item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                        "
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="red"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete item</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            <v-divider></v-divider>
          </tbody>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-if="dialogSendPay" v-model="dialogSendPay" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header color="#193D6E" v-if="e1 < 3" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="e1 > 1" step="1" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3" color="#193D6E"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Paso 1: Detalle de pago -->
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.invoices.selectTypeOfWalletPay }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 px-4" v-if="!loading" style="display: flex; align-items: center; width: fit-content; margin: auto; gap: 30px; flex-wrap: wrap; justify-content: center;">
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'USD'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                        <div class="usd-balance">{{ "Wallet USD" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'USD'" color="#193D6E">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceUsd ? balanceUsd : 0) }} USD
                    </div>
                  </div>
                </v-card>
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'MXN'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                        <div class="usd-balance">{{ "Wallet MXN" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'MXN'" color="#193D6E">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceMxn ? balanceMxn : 0) }} MXN
                    </div>
                  </div>
                </v-card>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="selectedCurrency = null, dialogSendPay = false, cancel()"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="selectedCurrency === null"
                    @click="openPayNow(selected), e1 = 2"
                  > 
                    {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ texts.invoices.paymentDetail }}</span>
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                    <v-card class="d-flex pa-6 mb-4" outlined elevation="2"
                      style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                    >
                      <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                        <div>
                          <div style="margin-right: 30px">
                            <v-img v-if="selectedCurrency == 'USD'" src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                            <v-img v-else src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                            <div class="usd-balance">{{ selectedCurrency == 'USD' ? "Wallet USD" : "Wallet MXN" }}</div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                          ${{ formatMoney(selectedCurrency == 'USD' ? balanceUsd : balanceMxn) }} {{ selectedCurrency }}
                        </div>
                      </div>
                    </v-card>
                    <div style="max-width: 200px;">
                      <v-select
                        :label="'Sort exchange rate by'"
                        required
                        outlined
                        v-if="selectedCurrency == selectedDestCurrency"
                        :items="sortTypes"
                        style="border-radius: 10px"
                        v-model="sortType"
                      ></v-select>
                    </div>
                  </div>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th>{{ texts.invoices.invoiceToPay }}</th>
                        <th>{{ texts.invoices.customerName }}</th>
                        <th>{{ texts.invoices.clabe }}</th>
                        <th>{{ texts.invoices.amountToSend }}</th>
                        <th>{{ texts.invoices.destinationReceives }}</th>
                        <th>{{ texts.invoices.exchangeRate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="loadingCalculator">
                        <tr v-for="n in 3" :key="n">
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td></td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ formatMoney(invoice.dExchangeRate) }} MXN</td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + selectedCurrency}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn
                    color="#0075B8"
                    elevation="8"
                    class="mr-2 px-10"
                    style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 1, selectedCurrency = null"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="8"
                    class="white--text px-10"
                    :disabled="loadingCalculator || totalAmountOrigin > parseFloat(selectedCurrency == 'USD' ? balanceUsd : balanceMxn)"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    @click="sendVerification(3)"
                  >
                  {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <!-- Paso 2: Verificación OTP -->
            <v-stepper-content step="3" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ texts.twoFactor.twoFactor }}</span> 
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row; width: 600px">
                    <div>
                      <v-otp-input v-model="otp" length="6" type="number" color="#193D6E"></v-otp-input>
                      <p style="font-size: 14px; font-weight: 500;">{{ texts.twoFactor.enterCode }}</p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn 
                    color="#0075B8"
                    elevation="8"
                    class="mr-2 px-10"
                    style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="e1 = 2, otp = ''"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-btn 
                    color="#0075B8"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :disabled="otp.length < 6"
                    :loading="loading"
                    @click="payInvoice(), e1 = 4"
                  >
                    {{ texts.modalForm.confirmPay }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="4" elevation="0" class="pt-0">
              <v-btn icon @click="cancel(), getInvoices()" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-container class="mt-1">
                <div v-if="loadingPayment" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando pago...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ "Pago procesado correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el pago!
                  </v-card-title>
                </div>
                <v-card-text class="py-6 pb-0">
                  <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                    <div style="max-width: 200px;">
                      <v-select
                        :label="'Sort exchange rate by'"
                        required
                        disabled
                        outlined
                        v-if="selectedCurrency == selectedDestCurrency"
                        :items="sortTypes"
                        style="border-radius: 10px"
                        v-model="sortType"
                      ></v-select>
                    </div>
                  </div>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th>{{ texts.invoices.invoiceToPay }}</th>
                        <th>{{ texts.invoices.customerName }}</th>
                        <th>{{ texts.invoices.clabe }}</th>
                        <th>{{ texts.invoices.amountToSend }}</th>
                        <th>{{ texts.invoices.destinationReceives }}</th>
                        <th>{{ texts.invoices.exchangeRate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="loadingCalculator">
                        <tr v-for="n in 3" :key="n">
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td></td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ formatMoney(invoice.dExchangeRate) }} MXN</td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + selectedCurrency}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogConvert" v-model="dialogConvert" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header color="#0075B8" v-if="e1 < 3" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="e1 > 1" step="1" color="#0075B8"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="#0075B8"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3" color="#0075B8"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Paso 1: Selección de tarjeta -->
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ texts.invoices.selectTypeConversion }}</span> 
                </v-card-title>
                <v-card-text class="py-6 pb-0" v-if="!loading">
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" outlined :class="{ 'selected-card': selectedCard === 2 }" @click="selectCard(2)" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ texts.payments.paySeparate }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify">{{ texts.payments.paySeparateDescription }}</div>
                      </div>
                      <v-icon v-if="selectedCard === 2" color="#0075B8">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" :disabled="true" outlined :class="{ 'selected-card': selectedCard === 3 }" @click="selectCard(3)" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ texts.payments.payForward }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify"> {{isDisabledForward ? texts.dashboard.payForwardDescriptionDisabled : texts.payments.payForwardDescription }}</div>
                      </div>
                      <v-icon v-if="selectedCard === 3" color="#0075B8">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn 
                    color="#0075B8"
                    elevation="8"
                    class="mr-2 px-10"
                    style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="cancel()"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-btn 
                    color="#0075B8"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    @click="openPayNow(selected), e1 = 2"
                    :disabled="selectedCard === null"
                  >
                    {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <!-- Paso 2: Detalles según selección -->
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ selectedCard === 2 ? texts.invoices.conversionDetail : texts.invoices.forwardDetail }}</span>
                </v-card-title>
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <v-card class="d-flex pa-6 mb-4" outlined elevation="2"
                    style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                  >
                    <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                      <div>
                        <div style="margin-right: 30px">
                          <v-img v-if="baseCurrency == 'USD'" src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                          <v-img v-else src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                          <div class="usd-balance">{{ baseCurrency == 'USD' ? "Wallet USD" : "Wallet MXN" }}</div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                        ${{ formatMoney(baseCurrency == 'USD' ? balanceUsd : balanceMxn) }} {{ selectedCurrency }}
                      </div>
                    </div>
                  </v-card>
                  <div style="max-width: 200px;">
                    <v-select
                      :label="'Sort exchange rate by'"
                      required
                      outlined
                      v-if="selectedCurrency == selectedDestCurrency"
                      :items="sortTypes"
                      style="border-radius: 10px"
                      v-model="sortType"
                    ></v-select>
                  </div>
                </div>
                <v-card-text class="pt-4 pb-0 px-0">
                  <div v-if="selectedCard === 3" class="pt-4 px-4 mb-4" style="display: flex; justify-content: center; background-color: #e5f6fd; flex-direction: row; border-radius: 15px;">
                    <div>
                      <v-icon color="#2c93d6" style="margin-right: 12px">mdi-alert-octagon-outline</v-icon>
                    </div>
                    <div>
                      <p style="font-size: 16px; font-weight: 700; color: #014361">{{ texts.invoices.forwardConditions }}</p>
                      <p style="font-size: 14px; font-weight: 500; color: #014361" class="mb-0">{{ texts.invoices.forwardConditions1 }}</p>
                      <v-divider class="my-4"></v-divider>
                      <p style="font-size: 14px; font-weight: 500; color: #014361">{{ texts.invoices.forwardConditions2 }}</p>
                    </div>
                  </div>
                  <v-simple-table>
                    <template v-if="loadingCalculator">
                        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
                    </template>
                    <template v-else>
                      <thead>
                        <tr>
                          <th>{{ texts.invoices.invoiceToPay }}</th>
                          <th>{{ texts.invoices.customerName }}</th>
                          <th>{{ texts.invoices.clabe }}</th>
                          <th>{{ texts.invoices.amountToSend }}</th>
                          <th>{{ texts.invoices.destinationReceives }}</th>
                          <th>{{ texts.invoices.exchangeRate }}</th>
                          <th v-if="selectedCard === 3">Forward Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ selectedCard == 2 ? formatMoney(invoice.dExchangeRate) : (invoice.dForwardExchangeRate ? formatMoney(invoice.dForwardExchangeRate) : "") }} MXN</td>
                          <td v-if="selectedCard === 3">
                            <v-dialog v-if="dialogConvert" ref="dialog" v-model="invoice.modal" width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn text :color="invoice.dForwardDate ? 'primary' : 'grey'" v-bind="attrs" v-on="on">
                                  {{ invoice.dForwardDate ? formatDate(invoice.dForwardDate) : "Select Date" }}
                                </v-btn>
                              </template>
                              <v-date-picker v-model="invoice.dForwardDate" :min="today" :allowed-dates="onlyWeekdays" :max="limit" scrollable @input="getForwardRate(invoice)">
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="closeDatePicker(invoice)"
                                  >
                                  Cancel
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + (selectedCurrency ? selectedCurrency : baseCurrency)}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div v-if="selectedCard === 3" class="pt-4 px-4 my-4 mt-6" style="display: flex; justify-content: center; background-color: #fff4e5; flex-direction: row; border-radius: 15px;">
                    <div>
                      <v-icon color="rgb(237, 108, 2)" style="margin-right: 12px">mdi-alert-outline</v-icon>
                    </div>
                    <div>
                      <p style="font-size: 16px; font-weight: 700; color: rgb(102, 60, 0)">{{ texts.invoices.forwardConditions3 }}</p>
                      <p style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                        {{ texts.invoices.forwardConditions4 }} {{ texts.invoices.forwardConditions5 }}
                      </p>
                      <v-checkbox v-model="checkboxModel" color="primary" hide-details class="pb-5">
                        <template v-slot:label>
                          <div style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                            {{ texts.invoices.forwardConditions6 }} <span style="font-size: 18px; font-weight: bold;">{{ totalAmountOrigin ? formatMoney(totalAmountOrigin * .5) + ' USD' : 'N/A' }}</span> {{ texts.invoices.forwardConditions7 }}
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn 
                    color="#0075B8"
                    elevation="8"
                    class="mr-2 px-10"
                    style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="e1 = 1, checkboxModel = false"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-btn 
                    color="#0075B8"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :disabled="selectedCard == 3 ? !checkboxModel || !allDatesSelected || !allRatesSelected || loadingCalculator : loadingCalculator || baseCurrency == 'USD' ? totalAmountOrigin > parseFloat(balanceUsd) : totalAmountOrigin > parseFloat(balanceMxn)"
                    @click="sendVerificationTransaction"
                  >
                    {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <!-- Paso 3: Verificación OTP -->
            <v-stepper-content step="3" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ texts.twoFactor.twoFactor }}</span>
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row; width: 600px">
                    <div>
                      <v-otp-input v-model="otp" length="6" type="number" color="#193D6E"></v-otp-input>
                      <p style="font-size: 14px; font-weight: 500;">{{ texts.twoFactor.enterCode }}</p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn 
                    color="#0075B8"
                    elevation="8"
                    class="mr-2 px-10"
                    style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="e1 = 2"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-btn 
                    color="#0075B8"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :disabled="otp.length < 6"
                    :loading="loading"
                    @click="convertInvoice(), e1 = 4"
                  >
                    {{ texts.modalForm.confirmConvert }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <v-stepper-content step="4" elevation="0" class="pt-0">
              <v-btn icon @click="cancel(), getInvoices()" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-container class="mt-1">
                <div v-if="loadingConversion" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando conversion...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ "Conversion realizada correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al realizar la conversion!
                  </v-card-title>
                </div>
                <v-card-text class="pt-4 pb-0 px-0">
                  <v-simple-table>
                    <template v-if="loadingCalculator">
                        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
                    </template>
                    <template v-else>
                      <thead>
                        <tr>
                          <th>{{ texts.invoices.invoiceToPay }}</th>
                          <th>{{ texts.invoices.customerName }}</th>
                          <th>{{ texts.invoices.clabe }}</th>
                          <th>{{ texts.invoices.amountToSend }}</th>
                          <th>{{ texts.invoices.destinationReceives }}</th>
                          <th>{{ texts.invoices.exchangeRate }}</th>
                          <th v-if="selectedCard === 3">Forward Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ selectedCard == 2 ? formatMoney(invoice.dExchangeRate) : (invoice.dForwardExchangeRate ? formatMoney(invoice.dForwardExchangeRate) : "") }} MXN</td>
                          <td v-if="selectedCard === 3">
                            <v-dialog v-if="dialogConvert" ref="dialog" v-model="invoice.modal" width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn text :color="invoice.dForwardDate ? 'primary' : 'grey'" v-bind="attrs" v-on="on">
                                  {{ invoice.dForwardDate ? formatDate(invoice.dForwardDate) : "Select Date" }}
                                </v-btn>
                              </template>
                              <v-date-picker v-model="invoice.dForwardDate" :min="today" :allowed-dates="onlyWeekdays" :max="limit" scrollable @input="getForwardRate(invoice)">
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="closeDatePicker(invoice)"
                                  >
                                  Cancel
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + (selectedCurrency ? selectedCurrency : baseCurrency)}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div v-if="selectedCard === 3" class="pt-4 px-4 my-4 mt-6" style="display: flex; justify-content: center; background-color: #fff4e5; flex-direction: row; border-radius: 15px;">
                    <div>
                      <v-icon color="rgb(237, 108, 2)" style="margin-right: 12px">mdi-alert-outline</v-icon>
                    </div>
                    <div>
                      <p style="font-size: 16px; font-weight: 700; color: rgb(102, 60, 0)">{{ texts.invoices.forwardConditions3 }}</p>
                      <p style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                        {{ texts.invoices.forwardConditions4 }} {{ texts.invoices.forwardConditions5 }}
                      </p>
                      <v-checkbox v-model="checkboxModel" color="primary" hide-details class="pb-5">
                        <template v-slot:label>
                          <div style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                            {{ texts.invoices.forwardConditions6 }} <span style="font-size: 18px; font-weight: bold;">{{ totalAmountOrigin ? formatMoney(totalAmountOrigin * .5) + ' USD' : 'N/A' }}</span> {{ texts.invoices.forwardConditions7 }}
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </v-card-text>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialog" v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title style="display: flex; justify-content: center">
          <span style="font-family: 'montserrat-bold'; font-size: 25px;">{{ texts.invoices.addInvoice }}</span> 
        </v-card-title>
        <v-card-subtitle class="pb-4 mt-3" style="text-align: center;">
          <span style="font-family: 'montserrat-semibold'; font-size: 15px;">{{ texts.invoices.addInvoiceDetailText }}</span>
        </v-card-subtitle>
        <v-card-text class="pb-1">
          <v-container>
            <v-row>
              <v-form
                ref="formNew"
                style="width: 100%"
                lazy-validation
                v-on:submit.prevent
              >
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="texts.invoices.invoice + '*'" 
                      required
                      style="border-radius: 10px"
                      outlined
                      v-model="forms.new.sInvoice"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="texts.invoices.sId"
                      required
                      style="border-radius: 10px"
                      outlined
                      v-model="forms.new.sId"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-autocomplete
                      :label="texts.invoices.supplier + '*'" 
                      required
                      style="border-radius: 10px"
                      :items="suppliers"
                      outlined
                      item-text="sName"
                      return-object
                      v-model="forms.new.sSupplier"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="texts.invoices.purchaseDate + '*'" 
                      required
                      style="border-radius: 10px"
                      outlined
                      type="date"
                      v-model="forms.new.dPurchaseDate"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      :label="(forms?.new?.sSupplier?.sAccountCurrency === 'MXN' ? texts.invoices.totalAmountMXN : texts.invoices.totalAmountUSD) + '*'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="forms.new.dTotalAmount"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="texts.invoices.creditTime + '*'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="forms.new.iCreditPeriod"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="texts.invoices.exchangeRateProtected + '*'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="forms.new.dRateProtection"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-row>
          </v-container>
          <small>*{{ texts.invoices.requiredField }}</small>
        </v-card-text>
        <v-card-actions class="py-4 pb-6" style="justify-content: space-evenly;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 px-10"
            style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="cancel()"
          >
            {{ texts.modalForm.cancel }}
          </v-btn>
          <v-btn
            color="#0075B8"
            elevation="8"
            class="white--text px-10"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="loading"
            :loading="loading"
            @click="saveInvoice(false)"
          > 
            {{ texts.modalForm.save }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogDuplicate" v-model="dialogDuplicate" persistent max-width="fit-content">
      <v-card>
        <v-card-title class="text-h5 my-4">
          {{ texts.invoices.invoiceDuplicateTitle }}
        </v-card-title>
        <v-card-text v-if="!loading" class="my-6">
          {{ texts.invoices.invoiceDuplicateSubtitle }}
        </v-card-text
        >
        <div v-else style="display: flex; justify-content: center">
          <v-progress-circular indeterminate color="amber"></v-progress-circular>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text :disabled="loading" @click="dialogDuplicate = false"> {{ texts.modalForm.cancel }} </v-btn> 
          <v-btn color="#193D6E" :disabled="loading" @click="saveInvoice(true)" style="color: white;">
            {{ texts.modalForm.save }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogEditInvoice" v-model="dialogEditInvoice" persistent max-width="600px">
      <v-card>
        <v-card-title style="display: flex; justify-content: center">
          <span class="text-h5">{{ texts.invoices.editInvoice }}</span> 
        </v-card-title>
        <v-card-subtitle class="pb-0 mt-3">
          <span style="font-size: 15px"
            >{{ texts.invoices.addInvoiceDetail }}</span>
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-row>
              <v-form
                ref="formEdit"
                style="width: 100%"
                lazy-validation
                v-on:submit.prevent
              >
                <v-col cols="12">
                  <v-text-field
                    :label="texts.invoices.invoice + '*'"
                    required
                    v-model="forms.detail.sInvoice"
                    :rules="[rules.required]"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="texts.invoices.sId"
                    v-model="forms.detail.sId"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    :label="texts.invoices.supplier + '*'" 
                    required
                    :items="suppliers"
                    return-object
                    item-text="sName"
                    v-model="forms.detail.sSupplier"
                    :rules="[rules.required]"
                    :disabled="loading"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="texts.invoices.purchaseDate + '*'" 
                    required
                    type="date"
                    v-model="forms.detail.dPurchaseDate"
                    :rules="[rules.required]"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="texts.invoices.totalAmountMXN + '*'" 
                    required
                    type="number"
                    v-model="forms.detail.dTotalAmount"
                    :rules="[rules.required]"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="texts.invoices.creditTime + '*'" 
                    required
                    type="number"
                    v-model="forms.detail.iCreditPeriod"
                    :rules="[rules.required]"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="texts.invoices.exchangeRateProtected + '*'" 
                    required
                    type="number"
                    v-model="forms.detail.dRateProtection"
                    :rules="[rules.required]"
                    :disabled="loading"
                  ></v-text-field>
                </v-col>
              </v-form>
            </v-row>
          </v-container>
          <small>*{{ texts.invoices.requiredField }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
              <v-btn color="black" text :disabled="loading" @click="cancel()"> {{ texts.modalForm.cancel }} </v-btn>
              <v-btn class="button-save"
                style="max-width: 200px; color: #FFF; background-color: #193D6E;"
                elevation="0"
                :disabled="loading"
                @click="updateInvoice()"> 
                {{ texts.modalForm.save }}
              </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogDelete" v-model="dialogDelete" persistent max-width="fit-content">
      <v-card class="pt-5">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <v-img :src="require('@/assets/icons/delete.svg')" style="width: 70px; height: 70px; margin-bottom: -40px;"></v-img>
          <v-card-title class="text-h5 my-4 mt-0 mx-10 pt-10 pb-6 px-8" style="border-radius: 10px; background-color: #E31D1C; color: white; font-family: 'montserrat-semibold' !important;">
            {{ texts.invoices.invoiceDeleteTitle }}
          </v-card-title>
          <v-card-text v-if="!loading" class="mt-4" style="text-align: center; font-family: 'montserrat-semibold'; font-size: 18px;">{{ texts.invoices.invoiceDeleteMessage }}</v-card-text>
          <div v-else style="display: flex; justify-content: center;">
            <v-progress-circular
              indeterminate
              color="amber"
            ></v-progress-circular>
          </div>
        </div>
        <v-card-actions class="pb-4 mt-8" style="justify-content: space-evenly;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 px-10"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="cancel()"
          >
            {{ texts.modalForm.cancel }}
          </v-btn>
          <v-btn
            color="red"
            elevation="8"
            class="white--text px-10"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="loading"
            @click="deleteInvoice()"
          >
            {{ texts.modalForm.delete }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo de detalle de factura -->
    <v-dialog v-model="dialogInvoiceDetail" max-width="1400px" scrollable>
      <v-card>
        <v-card-text class="pa-0">
          <InvoiceDetail
            v-if="selectedInvoiceId"
            :s-invoice-id="selectedInvoiceId"
            @back="dialogInvoiceDetail = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import InvoiceDetail from "./InvoiceDetail.vue";

export default {
  components: {
    InvoiceDetail,
  },
  name: "DashboardView",
  data() {
    return {
      nameXLSX: "FacturasPorAsignar.xlsx",
      modal: false,
      dialogForward: false,
      loadingExchange: false,
      loadingCalculator: false,
      texts: "",
      currentDate: moment(),
      currentDateCdmx: moment().clone().utcOffset("-06:00"),
      isDisabledForward: false,
      selectedCard: 0,
      dialog: false,
      otp: "",
      blockedUsd: 0,
      checkboxModel: false,
      dialogEditInvoice: false,
      dialogInvoiceDetail: false,
      selectedInvoiceId: null,
      allDatesSelected: false,
      allRatesSelected: false,
      dialogDelete: false,
      dialogSendPayMxn: false,
      dialogForex: false,
      loadingPayment: false,
      paymentError: null,
      loadingConversion: false,
      conversionError: null,
      sExchangeRateReference: null,
      drawer: null,
      actualCurrency: "0",
      actualCurrencyMxn: "0",
      referenceCurrency: "0",
      dialogConvert: false,
      search: "",
      isLoading: false,
      isLoadingStart: false,
      isRegisterEfex: true,
      invoices: [],
      exchangeRateData: [],
      totalAmountMxn: 0,
      selected: [],
      ifHaveAmount: false,
      exchangeRateDataPaid: [],
      exchangeRateDataSeparate: [],
      balanceMxn: "0",
      balanceUsd: "0",
      countdownDashboard: 59,
      balance: "0",
      selected: [],
      items: [],
      selectedSupplier: "",
      selectedStatus: 0,
      limit: null,
      tab: 0,
      contacts: [],
      today: null,
      itemsSelected: [],
      itemsSelectedForwards: [],
      isForwardRateCalculated: false,
      bSelectedAll: false,
      dialogAddFoundss: false,
      sortTypes: [
        { text: this.selectLanguage === 'en' ? "Ascending" : "Ascendente", value: "asc" },
        { text: this.selectLanguage === 'en' ? "Descending" : "Descendente", value: "desc" },
      ],
      sortType: "asc",
      dialogSendPay: false,
      dialogAddFounds: false,
      dataAddFounds: {},
      dialogCreate: false,
      dialogPay: false,
      editableData: {},
      selectedCard: null,
      totalUsd: 0,
      loading: false,
      selectedMenuItem: "dashboard",
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY",
      },
      isForwardsActive: false,
      dDateForward: null,
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      bLoading: false,
      isDeferredPayment: false,
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
      },
      forms: {
        new: {
          dPurchaseDate: "",
          sPaymentRecipientId: "",
          sInvoice: "",
          sId: "",
          dTotalAmount: "",
          dRateProtection: "",
          iCreditPeriod: "",
        },
        detail: {
          sInvoiceId: "",
          dPurchaseDate: "",
          sPaymentRecipientId: "",
          sInvoice: "",
          sId: "",
          dTotalAmount: "",
          dRateProtection: "",
          iCreditPeriod: "",
        },
        delete: {
          sInvoiceId: "",
        },
      },
      stepper: false,
      e1: 1,
      suppliers: [],
      status: [
        { sName: "To pay", sStatusId: "453f47d8-d5ad-4159-be49-b48b0f04caa5" },
        { sName: "Converted", sStatusId: "904a91ab-bdfc-45dc-a72f-fc02c2a15005" },
        { sName: "Paid", sStatusId: "f42d5b71-bcc8-4c2c-997a-40ad2da2bc31" },
      ],
      timerCount: 30,
      headersInvoices: [
        this.selectLanguage === 'en' ? { text: "Supplier", value: "sName", align: "center" } : { text: "Proveedor", value: "sName", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase date", value: "dPurchaseDate", align: "center" } : { text: "Fecha de compra", value: "dPurchaseDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Due date", value: "dDueDate", align: "center" } : { text: "Fecha de vencimiento", value: "dDueDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Invoice", value: "sInvoice", align: "center" } : { text: "Factura", value: "sInvoice", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase Order", value: "sId", align: "center" } : { text: "Orden de compra", value: "sId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Status", value: "sStatusId", align: "center" } : { text: "Estado", value: "sStatusId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dTotalAmount", align: "center" } : { text: "Monto total MXN", value: "dTotalAmount", align: "center" },
        this.selectLanguage === 'en' ? { text: "Exchange rate protection MXN", value: "dRateProtection", align: "center", sortable: false } : { text: "Cobertura de tasa de cambio MXN", value: "dRateProtection", align: "center", sortable: false },   
        this.selectLanguage === 'en' ? { text: "Currency profit (%)", value: "dProfitPercentage", align: "center" } : { text: "Beneficio de moneda (%)", value: "dProfitPercentage", align: "center" },
        this.selectLanguage === 'en' ? { text: "Currency gain", value: "dCurrencyGain", align: "center" } : { text: "Beneficio de moneda", value: "dCurrencyGain", align: "center" },
        this.selectLanguage === 'en' ? { text: "Actions", value: "actions", align: "center" } : { text: "Acciones", value: "actions", align: "center" }
      ],
      headersInvoicesConverted: [
        this.selectLanguage === 'en' ? { text: "Supplier", value: "sName", align: "center" } : { text: "Proveedor", value: "sName", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase date", value: "dPurchaseDate", align: "center" } : { text: "Fecha de compra", value: "dPurchaseDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Due date", value: "dDueDate", align: "center" } : { text: "Fecha de vencimiento", value: "dDueDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Invoice", value: "sInvoice", align: "center" } : { text: "Factura", value: "sInvoice", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase Order", value: "sId", align: "center" } : { text: "Orden de compra", value: "sId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Status", value: "sStatusId", align: "center" } : { text: "Estado", value: "sStatusId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Avaible payment", value: "sTransactionAvaible", align: "center" } : { text: "Pago disponible", value: "sTransactionAvaible", align: "center" },
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dTotalAmount", align: "center" } : { text: "Monto total MXN", value: "dTotalAmount", align: "center" },
        this.selectLanguage === 'en' ? { text: "Exchange rate protection MXN", value: "dRateProtection", align: "center", sortable: false } : { text: "Cobertura de tasa de cambio MXN", value: "dRateProtection", align: "center", sortable: false },   
        this.selectLanguage === 'en' ? { text: "Currency profit (%)", value: "dProfitPercentage", align: "center" } : { text: "Beneficio de moneda (%)", value: "dProfitPercentage", align: "center" },
        this.selectLanguage === 'en' ? { text: "Currency gain", value: "dCurrencyGain", align: "center" } : { text: "Beneficio de moneda", value: "dCurrencyGain", align: "center" },
        this.selectLanguage === 'en' ? { text: "Actions", value: "actions", align: "center" } : { text: "Acciones", value: "actions", align: "center" }
      ],
      timerId: null,
      dataEfex: {},
      exchangeRateAdjustments: [],
      exchangeRatesStateForwards: [],
      isPayMxn: false,
      bSelectedAllSeparate: false,
      isForwards: false,
      isForwardsPayment: false,
      userName: "",
      forwardRate: null,
      modalCurrency: 0,
      forwardActualRate: null,
      selectedId: "",
      sections: [
        {
          icon: "mdi mdi-view-dashboard",
          value: "operation",
          title: "Operaciones",
          items: [
            {
              icon: "mdi mdi-view-dashboard",
              value: "dashboard",
              title: "Dashboard",
              disabled: false,
            },
            {
              icon: "mdi-file-document",
              value: "history",
              title: "Seguimiento de facturas",
              disabled: false,
            },
            {
              icon: "mdi-forward",
              value: "activeForwards",
              title: "Forwards activos",
              disabled: false,
            },
          ],
        },
        {
          icon: "mdi-history",
          value: "history",
          title: "Historial",
          items: [
            {
              icon: "mdi-file-document",
              value: "exchangeRate",
              title: "Historial de conversiones",
              disabled: true,
            },
            {
              icon: "mdi-file-document",
              value: "history",
              title: "Historial de pagos",
              disabled: false,
            },
          ],
        },
        {
          icon: "mdi-wallet",
          value: "wallets",
          title: "Wallets",
          items: [
            {
              icon: "mdi-account-group",
              value: "suppliers",
              title: "Proveedores",
              disabled: true,
            },
            {
              icon: "mdi-account-group",
              value: "suppliers",
              title: "Estado de cuenta",
              disabled: true,
            },
          ],
        },
      ],
      payDetail: {
        supplier: "",
        totalUSD: "",
        exchangeRate: "",
        dTotalAmount: "",
        sAccountNumber: "",
        exchangeRateToday: "",
        sInvoice: "",
      },
      totalAmountUsd: 0,
      totalAmountMxn: 0,
      forexDetail: {
        sInvoice: "",
        totalUSD: "",
        exchangeRate: "",
        dTotalAmount: "",
      },
      forwardDetail: {
        sInvoice: "",
        totalUSD: "",
        exchangeRate: "",
        dTotalAmount: "",
        totalAmountPercentage: "",
      },
      miniVariant: true,
      expandOnHover: false,
      registerFields: [
        { model: "sBankName", type: "text", label: "sBankName" },
        { model: "sAccountNumber", type: "text", label: "sAccountNumber" },
        { model: "sRoutingNumber", type: "text", label: "sRoutingNumber" },
      ],
      transactions: [],
      dialogDuplicate: false,
      baseCurrency: "",
      targetCurrency: "",
      operationType: "",
      select: [],
      totalAmountOrigin: 0,
      totalAmountDest: 0,
      selectedCurrency: "",
      selectedDestCurrency: null,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    tabStyle(tabIndex) {
      return {
        color: this.tab === tabIndex ? "#193D6E" : "#506172",
        fontSize: "16px",
        fontWeight: "600",
        width: "200px",
        lineHeight: "24px",
        fontFamily: "montserrat-bold",
      };
    },
    openDialogSupplier() {
      this.dialog = true;
    },
    async toggleSelect(item) {
      const alreadySelected = this.isSelected(item);
      const destCurrency = item.paymentsRecipent[0].sAccountCurrency;

      if (alreadySelected) {
        this.selected = this.selected.filter(
          (selectedItem) => selectedItem.sInvoiceId !== item.sInvoiceId
        );

        if (this.selected.length === 0) {
          this.selectedDestCurrency = null;
        }

        return;
      }

      if (this.selected.length === 0) {
        this.selectedDestCurrency = destCurrency;
        this.selected.push(item);
        return;
      }

      if (this.selectedDestCurrency !== destCurrency) {
        this.mixWarning("Solo puedes seleccionar facturas con la misma moneda destino.");
        return;
      }

      this.selected.push(item);
    },
    // toggleSelect(item) {
    //   const index = this.selected.findIndex(
    //     (selectedItem) => selectedItem.sInvoiceId === item.sInvoiceId
    //   );
    //   if (index === -1) {
    //     this.selected.push(item);
    //   } else {
    //     this.selected.splice(index, 1);
    //   }
    // },
    // toggleSelect(item) {
    //   const index = this.selected.findIndex(
    //     (selectedItem) => selectedItem.sInvoiceId === item.sInvoiceId
    //   );
    //   if (index === -1) {
    //     this.selected.push(item);
    //   } else {
    //     this.selected.splice(index, 1);
    //   }
    // },
    isSelected(item) {
      return this.selected.some(
        (selectedItem) => selectedItem.sInvoiceId === item.sInvoiceId
      );
    },
    openConvert(item) {
      this.dialogConvert = true;
    },
    async sendVerification(step) {
      // Verifica si el paso es 3 y valida el balance
      if (step === 3) {
        const requiredAmount = this.forwardDetail.totalUSD * 0.05;
        if (requiredAmount > this.balanceUsd) {
          this.mixError(this.texts.invoices.amountError, 400);
          this.loading = false;
          return;
        }
      }

      // Asigna el paso actual
      this.e1 = step;

      try {
        // Obtiene el token de autorización de forma más segura
        const token = this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "";

        // Realiza la solicitud GET
        const response = await DB.get(`${URI}/api/v1/${this.selectLanguage}/authenticator/`, {
          headers: { Authorization: token }
        });

        const { data, status } = response;

        // Maneja la respuesta exitosa pero con success falso
        if (!data.success) {
          this.mixError(data.message, status);
        }
      } catch (error) {
        // Manejo de errores más robusto
        const errMessage = error?.response?.data?.message || 'Ocurrió un error inesperado.';
        const errStatus = error?.response?.status || 500;
        this.mixError(errMessage, errStatus);
      } finally {
        // Asegura que el indicador de carga se desactive siempre
        this.loading = false;
      }
    },
    roundHalfEven(num, decimals = 2) {
      const factor = Math.pow(10, decimals);
      const temp = num * factor;
      const floor = Math.floor(temp);
      const diff = temp - floor;

      if (diff === 0.5) {
        return (floor % 2 === 0 ? floor : floor + 1) / factor;
      }

      return Math.round(temp) / factor;
    },
    async calculatorAmount(amount, rate) {
      const headers = {
        Authorization: this.$store.state.sToken
          ? `Bearer ${this.$store.state.sToken}`
          : "",
      }
      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/dashboard/calculatorAmount`, {
          amount: amount,
          rate: rate,
          reverse: true
        }, { headers });
        return this.roundHalfEven(response.data.data.result, 2).toFixed(2);
      } catch (error) {

        return null;
      }
    },
    async openPayNow(items) {
      this.loadingCalculator = true;
      this.totalAmountOrigin = 0;
      this.totalAmountDest = 0;

      const originCurrency = this.selectedCurrency ? this.selectedCurrency : this.baseCurrency;

      this.payDetail.invoices = await Promise.all(items.map(async (item) => {
        const destCurrency = item.paymentsRecipent[0].sAccountCurrency;
        let dOriginAmount = item.dTotalAmount;
        let sExchangeRateReference = null;
        let exchangeRateToday = null;

        if (originCurrency !== destCurrency) {
          const payload = {
            currency: originCurrency,
            desCurrency: destCurrency,
          };

          const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/dashboard/getExchangeRate`, payload, {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
            }
          });
          exchangeRateToday = response.data.exchangeRateToday;
          sExchangeRateReference = response.data.exchangeRateTodayReference;
          dOriginAmount = await this.calculatorAmount(item.dTotalAmount, sExchangeRateReference);
        }

        return {
          sInvoiceId: item.sInvoiceId,
          supplier: item.sName,
          sInvoice: item.sInvoice,
          dExchangeRate: exchangeRateToday,
          sAccountNumber: (item.paymentsRecipent[0].accountNumber ? item.paymentsRecipent[0].accountNumber.slice(-4) : item.paymentsRecipent[0].sAccountNumber.slice(-4)),
          dOriginAmount,
          dDestAmount: item.dTotalAmount,
          sExchangeRateReference,
          originCurrency,
          destCurrency,
          sPaymentRecipientId: item.sPaymentRecipientId,
          reverse: originCurrency !== destCurrency
        };
      }));

      // Calcular totales
      this.totalAmountOrigin = Math.ceil(
        this.payDetail.invoices.reduce((sum, invoice) => sum + parseFloat(invoice.dOriginAmount), 0) * 100
      ) / 100;

      this.totalAmountDest = this.payDetail.invoices.reduce(
        (sum, invoice) => sum + parseFloat(invoice.dDestAmount),
        0
      );

      this.loadingCalculator = false;
    },
    async payInvoiceMxn() {
      this.loading = true;

      const isOtpValid = await this.validateOtp();

      if (!isOtpValid) {
        this.loading = false;
        this.mixError('Invalid code', 400);
        return;
      }

      const payload = {
        invoices: this.payDetail.invoices.map(invoice => ({
          sInvoiceId: invoice.sInvoiceId,
          comment: invoice.comment
        })),
      };

      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/payments/sendPaymentMasiveFromInvoices`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        });

        if (!response.data.success) {
          this.mixError(response.data.message, response.data.status);
          this.loading = false;
          return;
        }
        else {
          this.loading = false;
          this.mixSuccess(response.data.message, response.data.status);
          this.getInvoices();
          this.cancelPayMxn();
        }
      } catch (error) {
        this.mixError(error.response.data.message, error.response.status);
        this.loading = false;
        return;
      }

      this.loading = false;
      this.getInvoices();
      this.cancelPayMxn();


    },
    selectCard(cardNumber) {
      this.selectedCard = cardNumber;
    },
    async selectTypeConversion(cardNumber) {
      this.loadingCalculator = true;
      this.e1 = 2;
      this.loading = true;

      //const exchangeRateReference = parseFloat(this.sExchangeRateReference);
      const exchangeRateToday = parseFloat(this.payDetail.exchangeRateToday);

        // Helper function to process invoices
      const processInvoices = async (items, extraFields = {}) => {
        const invoicePromises = items.map(async item => {
            let dTotalUsd = await this.calculatorAmount(item.dTotalAmount, this.sExchangeRateReference);
            dTotalUsd = Math.floor(dTotalUsd * 100) / 100;
            return {
            sInvoiceId: item.sInvoiceId,
            supplier: item.sName,
            sInvoice: item.sInvoice,
            dPurchaseDate: item.dPurchaseDate,
            dTotalUsd: parseFloat(dTotalUsd),
            dTotalAmount: parseFloat(item.dTotalAmount),
            sAccountNumber: (item.accountNumber.slice(-4) ? item.accountNumber.slice(-4) : item.sAccountNumber.slice(-4)),
            ...extraFields,
          };
        });
        return Promise.all(invoicePromises);
      };

      if (cardNumber === 2) {
        this.forexDetail.invoices = await processInvoices(this.selected, {
          exchangeRate: exchangeRateToday,
        });
        this.forexDetail.totalUSD = this.forexDetail.invoices.reduce(
          (sum, invoice) => sum + invoice.dTotalUsd,
          0
        );
        this.forexDetail.totalAmountMxn = this.forexDetail.invoices.reduce(
          (sum, invoice) => sum + invoice.dTotalAmount,
          0
        );
      }

      if (cardNumber === 3) {
        this.forwardDetail.invoices = await processInvoices(this.selected, {
          dForwardExchangeRate: 0.0,
        });

        this.forwardDetail.totalUSD = this.forwardDetail.invoices.reduce(
          (sum, invoice) => sum + invoice.dTotalUsd,
          0
        );
        this.forwardDetail.totalAmountMxn = this.forwardDetail.invoices.reduce(
          (sum, invoice) => sum + invoice.dTotalAmount,
          0
        );
      }

      this.loadingCalculator = false;
      this.loading = false;
    },
    sendVerificationTransaction(){
      this.e1 = 3;
      try {
        DB.get(`${URI}/api/v1/${this.selectLanguage}/authenticator/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }).then((response) => {
          if(!response.data.success){
           this.mixError(response.data.message, response.status);
          }
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
        }
        catch(error){
          this.mixError(error.response.data.message, error.response.status);
        }
    },
    async confirmTransaction(){
      this.loading = true;
      const isOtpValid = await this.validateOtp();

      if (!isOtpValid) {
        this.loading = false;
        this.mixError('Invalid code', 400);
        return;
      }

      if(this.selectedCard == 2){
         this.convertInvoice();
      }
      if(this.selectedCard == 3){
         this.sendForward();
      }
    },
    // getExchangeRate() {
    //   DB.get(`${URI}/api/v1/${this.selectLanguage}/dashboard`, {
    //     headers: {
    //       Authorization: this.$store.state.sToken
    //         ? `Bearer ${this.$store.state.sToken}`
    //         : "",
    //     },
    //   }).then((response) => {
    //     this.payDetail.exchangeRateToday = response.data.exchangeRateToday;
    //     this.sExchangeRateReference = response.data.exchangeRateTodayReference;
    //   });
    // },
    async getDashboard() {
      try {
        this.loading = true;

        const response = await DB.get(`${URI}/api/v1/${this.selectLanguage}/dashboard`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });
        this.items = response.data;
        this.balanceUsd = response.data.balances.balanceUsd.balance;
        this.balanceMxn = response.data.balances.balanceMxn.balance;
        this.blockedUsd = response.data.balances.blocked.balance;
        this.exchangeRateTodayReference = this.items.exchangeRateTodayReference;
        this.payDetail.exchangeRateToday = response.data.exchangeRateToday;
        this.sExchangeRateReference = response.data.exchangeRateTodayReference;

        this.getInvoices();
      } catch (error) {
        if (error.response.data.code) {
          this.$router.push("/welcome").catch(() => {});
        }

        this.mixError(error.response.data.message, error.response.status);
      } finally {
        this.loading = false;
      }
    },
    saveInvoice(isValid = false) {
      if (this.$refs.formNew.validate()) {
        this.loading = true;

        let payload = {
          dPurchaseDate: this.forms.new.dPurchaseDate,
          sPaymentRecipientId: this.forms.new.sSupplier.sPaymentRecipientId,
          sInvoice: this.forms.new.sInvoice,
          sId: this.forms.new.sId,
          dTotalAmount: this.forms.new.dTotalAmount,
          dRateProtection: this.forms.new.dRateProtection,
          iCreditPeriod: this.forms.new.iCreditPeriod,
          skipDuplicate: isValid,
          contactData: {
            create: false,
          },
        };

        DB.post(`${URI}/api/v1/${this.selectLanguage}/invoices/`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            if(response.status === 202){
              this.dialogDuplicate = true;
              this.loading = false;
              //this.mixError(response.data.message, response.status);
            }
            else {
              this.loading = false;
              this.dialogDuplicate = false;
              this.getInvoices();
              this.cancel();
            }
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    updateInvoice() {
      if (this.$refs.formEdit.validate()) {
        this.loading = true;

        let payload = {
          sInvoiceId: this.forms.detail.sInvoiceId,
          dPurchaseDate: this.forms.detail.dPurchaseDate,
          sPaymentRecipientId: this.forms.detail.sSupplier.sPaymentRecipientId,
          sInvoice: this.forms.detail.sInvoice,
          sId: this.forms.detail.sId,
          dTotalAmount: this.forms.detail.dTotalAmount,
          dRateProtection: this.forms.detail.dRateProtection,
          iCreditPeriod: this.forms.detail.iCreditPeriod,
        };

        DB.put(`${URI}/api/v1/${this.selectLanguage}/invoices/`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.loading = false;
            this.getInvoices();
            this.cancel();
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    deleteInvoice() {
      this.loading = true;

      let payload = {
        sInvoiceId: this.forms.delete.sInvoiceId,
      };

      DB.put(`${URI}/api/v1/${this.selectLanguage}/invoices/delete`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.loading = false;
          this.getInvoices();
          this.cancel();
        })
        .catch((error) => {
          this.loading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    editInvoice(item) {
      this.selectedInvoiceId = item.sInvoiceId;
      this.dialogInvoiceDetail = true;
      // this.dialogEditInvoice = true;
      // this.forms.detail.sInvoiceId = item.sInvoiceId;
      // this.forms.detail.sId = item.sId;
      // this.forms.detail.dPurchaseDate = item.dPurchaseDate;
      // this.forms.detail.sPaymentRecipientId = item.sPaymentRecipientId;
      // this.forms.detail.sInvoice = item.sInvoice;
      // this.forms.detail.dTotalAmount = item.dTotalAmount;
      // this.forms.detail.dRateProtection = item.dRateProtection;
      // this.forms.detail.iCreditPeriod = item.iCreditPeriod;
    },
    openDialogDeleteInvoice(item) {
      this.dialogDelete = true;
      this.forms.delete.sInvoiceId = item.sInvoiceId;
    },
    sendForward() {
      this.loading = true;
      const allDatesSelected = this.forwardDetail.invoices.every(invoice => invoice.dForwardDate);
      const allRatesSelected = this.forwardDetail.invoices.every(invoice => invoice.dForwardExchangeRate);
      if (!allDatesSelected || !allRatesSelected) {
        this.mixError('Please select all dates and rates.', 400);
        this.loading = false;
        return;
      }
    
      let payload = {
        invoices: this.forwardDetail.invoices.map(invoice => ({
          sInvoiceId: invoice.sInvoiceId,
          sTransactionType: "b80e8dc6-4138-449e-8903-968efb8437b3",
          dExchangeRate: invoice.dForwardExchangeRate,
          referenceExchangeRate: invoice.sForwardExchangeRate,
          dForwardTransactionDate: invoice.dForwardDate,
        })),
        bExternal: false,
        sTransactionType: "b80e8dc6-4138-449e-8903-968efb8437b3",
        dAmountRemaining: this.forwardDetail.totalUSD * 0.05,
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/transactions/createForwardTransactionFromInvoice`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
        .then((response) => {
          this.loading = false;
          this.getDashboard();
          this.cancel();
        })
        .catch((error) => {
          this.loading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    async validateOtp() {
      try {
            const payload = {
              sCode: this.otp
            };

        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/authenticator/verify`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

          return response.data.success;
        } catch (error) {
          console.error('Error in validateOtp:', error);
          return false;
        }
    },
    checkTime() {
      this.currentTime = this.currentDate.format("MMMM DD, YYYY, HH:mm:ss [GMT]Z");
      this.currentTimeCdmx = this.currentDateCdmx.format(
        "MMMM DD, YYYY, HH:mm:ss [GMT-6]"
      );
      const currentHourCdmx = this.currentDateCdmx.hour();
      const currentDayCdmx = this.currentDateCdmx.day();
      if (currentDayCdmx === 6 || currentDayCdmx === 0) {
        this.isDisabledForward = true;
      } else if (currentHourCdmx >= 9 && currentHourCdmx < 14) {
        this.isDisabledForward = false;
      } else {
        this.isDisabledForward = true;
      }
      if (currentDayCdmx === 6 || currentDayCdmx === 0) {
        this.isDisabledWindow = true;
      }
    },
    async payInvoice() {
      this.loadingPayment = true;

      const isOtpValid = await this.validateOtp();

      if (!isOtpValid) {
        this.loading = false;
        this.mixError('Invalid code', 400);
        return;
      }
      const payload = {
        invoices: this.payDetail.invoices.map(invoice => ({
          sInvoiceId: invoice.sInvoiceId,
          sInvoice: invoice.sInvoice,
          dOriginAmount: invoice.dOriginAmount,
          dDestAmount: invoice.dDestAmount,
          sPaymentRecipientId: invoice.sPaymentRecipientId,
          originCurrency: invoice.originCurrency,
          destCurrency: invoice.destCurrency,
          sExchangeRateReference: invoice.sExchangeRateReference,
          reverse: invoice.reverse
        })),
        originCurrency: this.selectedCurrency,
        paymentType: 'Spot',
        sortDirection: this.sortType,
      };

      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/invoices/payInvoices`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        });

        this.mixSuccess(response.data.message, response.data.status);
        this.paymentError = false
      } catch (error) {
        this.mixError(error.response.data.message, error.response.status);
        this.paymentError = true
      } finally {
        this.loadingPayment = false;
      }

    },
    async convertInvoice() {
      this.loadingConversion = true;

      const isOtpValid = await this.validateOtp();

      if (!isOtpValid) {
        this.loading = false;
        this.mixError('Invalid code', 400);
        return;
      }
      const payload = {
        invoices: this.payDetail.invoices.map(invoice => ({
          sInvoiceId: invoice.sInvoiceId,
          sInvoice: invoice.sInvoice,
          dOriginAmount: invoice.dOriginAmount,
          dDestAmount: invoice.dDestAmount,
          dExchangeRate: invoice.dExchangeRate,
          sPaymentRecipientId: invoice.sPaymentRecipientId,
          originCurrency: invoice.originCurrency,
          destCurrency: invoice.destCurrency,
          sExchangeRateReference: invoice.sExchangeRateReference,
          reverse: invoice.reverse
        })),
        sTransactionType: this.selectedCard === 2 ? 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a' : 'b80e8dc6-4138-449e-8903-968efb8437b3',
        dOriginCurrency: this.baseCurrency,
        dDestCurrency: this.targetCurrency
      };

      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/invoices/convertInvoices`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        });

        this.mixSuccess(response.data.message, response.data.status);
        this.paymentError = false
      } catch (error) {
        this.mixError(error.response.data.message, error.response.status);
        this.paymentError = true
      } finally {
        this.loadingConversion = false;
      }

    },
    cancel() {
      this.getDashboard();
      this.dialog = false;
      this.paymentError = null
      this.dialogDelete = false;
      this.dialogSendPay = false;
      this.forwardActualRate = null;
      this.selectedCard = null;
      this.dialogEditInvoice = false;
      this.dialogConvert = false;
      this.dDateForward = null;
      this.dialogForex = false;
      this.dialogForward = false;
      this.selected = [];
      this.otp = '';
      this.e1 = 1;
      this.checkboxModel = false;
      this.forwardDetail.totalAmountPercentage = 0;
      this.forms.new = {
        dPurchaseDate: "",
        sPaymentRecipientId: "",
        sInvoice: "",
        dTotalAmount: "",
        dRateProtection: "",
        iCreditPeriod: "",
      };
      this.forms.detail = {
        sInvoiceId: "",
        dPurchaseDate: "",
        sPaymentRecipientId: "",
        sInvoice: "",
        dTotalAmount: "",
        dRateProtection: "",
        iCreditPeriod: "",
      };
    },
    cancelPayMxn() {
      this.dialogSendPayMxn = false;
      this.dialogDelete = false;
      this.dialogSendPay = false;
      this.selectedStatus = 1;
      this.forwardActualRate = null;
      this.selectedCard = null;
      this.dialogEditInvoice = false;
      this.dialogConvert = false;
      this.dDateForward = null;
      this.dialogForex = false;
      this.dialogForward = false;
      this.selected = [];
      this.otp = '';
      this.e1 = 1;
      this.checkboxModel = false;
      this.forwardDetail.totalAmountPercentage = 0;
      this.forms.new = {
        dPurchaseDate: "",
        sPaymentRecipientId: "",
        sInvoice: "",
        dTotalAmount: "",
        dRateProtection: "",
        iCreditPeriod: "",
      };
      this.forms.detail = {
        sInvoiceId: "",
        dPurchaseDate: "",
        sPaymentRecipientId: "",
        sInvoice: "",
        dTotalAmount: "",
        dRateProtection: "",
        iCreditPeriod: "",
      };
    },
    async getForwardRate(invoice) {
      this.loadingExchange = true;
      const payload = {
        dDateForward: invoice.dForwardDate,
        dAmount: parseFloat(invoice.dDestAmount),
        referenceExchangeRate: this.sExchangeRateReference,
        bExternal: false,
        reverse: true,
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/transactions/forwardRate`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then(async (response) => {
          this.loadingExchange = false;
          invoice.dForwardExchangeRate = response.data.forwardRate.rate;
          invoice.sForwardExchangeRate = response.data.forwardRate.uuid;
          invoice.dForwardAmountPercentage = response.data.forwardRate.initial_percentage_amount;
          invoice.dOriginAmount = await this.calculatorAmount(invoice.dDestAmount, invoice.sForwardExchangeRate);
          this.updateAmountForwardMXN();
          const allDatesSelected = this.payDetail.invoices.every(invoice => invoice.dForwardDate);
          const allRatesSelected = this.payDetail.invoices.every(invoice => invoice.dForwardExchangeRate);
          this.allDatesSelected = allDatesSelected;
          this.allRatesSelected = allRatesSelected;
          invoice.modal = false;
        })
        .catch((error) => {
          this.loadingExchange = false;
          this.mixError(error.response.data.message, error.response.status);
          invoice.modal = false;
        });
    },
    updateAmountForwardMXN() {
      this.totalAmountOrigin = this.payDetail.invoices.reduce((sum, invoice) => sum + parseFloat(invoice.dOriginAmount), 0);
      this.totalAmountDest = this.payDetail.invoices.reduce((sum, invoice) => sum + parseFloat(invoice.dDestAmount), 0);
    },
    closeDatePicker(invoice) {
      invoice.modal = false;
      //this.getForwardRate(invoice);
    },
    getSuppliers() {
      DB.get(`${URI}/api/v1/${this.selectLanguage}/payment-recipient/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      }).then((response) => {
        this.suppliers = response.data.paymentRecipients;
      });
    },
    handleResize: function () {
      if (window.innerWidth >= 960) {
        this.screenWidth = 30;
      } else {
        this.screenWidth = 100;
      }

      this.isResponsive = window.innerWidth < 960;
    },
    async getInvoices() {
      this.isLoading = true;
      this.operationType = this.$store.state.OperationType;
      if (this.operationType === "Compra") {
        this.baseCurrency = 'MXN';
        this.targetCurrency = 'USD';
      } else {
        this.baseCurrency = 'USD';
        this.targetCurrency = 'MXN';
      }
      
      const payload = {
        sPaymentRecipientId: this.selectedSupplier,
        sStatusId: this.status[this.selectedStatus].sStatusId,
        sId: this.selectedId,
        currency: this.baseCurrency,
        des_currency: this.targetCurrency
      };
      DB.post(`${URI}/api/v1/${this.selectLanguage}/invoices/invoices`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.items = response.data;
          this.isLoading = false;
          this.totalAmountMxn = response.data.totalAmount;
          this.startCountdownDashboard();
          this.balanceUsd = response.data.balance.balanceUsd.balance;
          this.balanceMxn = response.data.balance.balanceMxn.balance;
          this.invoices = this.items.invoices;
          this.invoices = this.items.invoices.map(invoice => {
              const totalAmount = invoice.invoice_payments_relationship.reduce((sum, inv) => {
                      return sum + (parseFloat(inv.dAmount) || 0);
                  }, 0)
              invoice.totalAmount = totalAmount;
              return {
                  ...invoice,
              };
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLoadingSuppliers = false;
          this.mixError(error, 400);
        });
    },
    formatMoney(value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate(date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    closeDatePicker(invoice) {
      invoice.modal = false;
    },
    startCountdownDashboard() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.countdownDashboard = 60;
      this.intervalId = setInterval(() => {
        if (this.countdownDashboard > 0) {
          this.countdownDashboard--;
        } else {
          clearInterval(this.intervalId);
          if (
            this.dialogForward == false &&
            this.dialogDelete == false &&
            this.dialogSendPay == false &&
            this.dialogEditInvoice == false &&
            this.dialogConvert == false &&
            this.dialogForex == false
          ) {
            this.getInvoices();
          }
        }
      }, 1000);
    },
    onlyWeekdays(date) {
      const day = new Date(date).getDay();
      return day !== 5 && day !== 6;
    },
    updateHeaders() {
      this.headersInvoices = [
        { text: this.texts.invoices.supplier, value: "sName", align: "center" },
        { text: this.texts.invoices.purchaseDate, value: "dPurchaseDate", align: "center" },
        { text: this.texts.invoices.dueDate, value: "dDueDate", align: "center" },
        { text: this.texts.invoices.invoice, value: "sInvoice", align: "center" },
        { text: this.texts.invoices.sId, value: "sId", align: "center" },
        { text: this.texts.invoices.status, value: "sStatusId", align: "center" },
        { text: this.texts.invoices.totalAmountMXN, value: "dTotalAmount", align: "center" },
        { text: this.texts.invoices.rateProtection, value: "dRateProtection", align: "center" },
        { text: this.texts.invoices.profitPercentage, value: "dProfitPercentage", align: "center" },
        { text: this.texts.invoices.currencyGain, value: "dCurrencyGainMxn", align: "center" },
        { text: this.texts.invoices.actions, value: "actions", align: "center" }
      ];
      this.headersInvoicesConverted = [
        { text: this.texts.invoices.supplier, value: "sName", align: "center" },
        { text: this.texts.invoices.purchaseDate, value: "dPurchaseDate", align: "center" },
        { text: this.texts.invoices.dueDate, value: "dDueDate", align: "center" },
        { text: this.texts.invoices.invoice, value: "sInvoice", align: "center" },
        { text: this.texts.invoices.sId, value: "sId", align: "center" },
        { text: this.texts.invoices.status, value: "sStatusId", align: "center" },
        { text: this.texts.invoices.avaible, value: "sTransactionAvaible", align: "center" },
        { text: this.texts.invoices.totalAmountMXN, value: "dTotalAmount", align: "center" },
        { text: this.texts.invoices.rateProtection, value: "dRateProtection", align: "center" },
        { text: this.texts.invoices.profitPercentage, value: "dProfitPercentage", align: "center" },
        { text: this.texts.invoices.currencyGain, value: "dCurrencyGainMxn", align: "center" },
        { text: this.texts.invoices.actions, value: "actions", align: "center" }
      ];
    },
    dataXLSX() {
      try {
        let data = this.invoices.map((item) => {
          return {
            Supplier: item.sName ? item.sName : "",
            "Purchase date": item.dPurchaseDate ? this.formatDate(item.dPurchaseDate) : "",
            "Due date": item.dDueDate ? this.formatDate(item.dDueDate) : "N/A",
            Invoice: item.sInvoice ? item.sInvoice : "",
            "Purchase Order": item.sId ? item.sId : "",
            "Status": item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5' ? 'To Pay' : (item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005' ? 'Converted' : (item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31' ? 'Paid' : "N/A")),
            "Total amount (MXN)": item.dTotalAmount ? parseFloat(item.dTotalAmount) : "",
            "Exchange rate protection": item.dRateProtection ? item.dRateProtection : "",
            "Currency profit (%)": item.dProfitPercentage ? parseFloat(item.dProfitPercentage) : "",
            "Currency gain (MXN)": item.dCurrencyGainMxn ? parseFloat(item.dCurrencyGainMxn) : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.updateHeaders();
    this.getSuppliers();
    this.checkTime();
    // this.getExchangeRate();
    this.getInvoices();
    this.today = moment().add(1, "day").format("YYYY-MM-DD");
    this.limit = moment(this.today).add(1, "year").format("YYYY-MM-DD");
  },
  beforeDestroy() {
    // Limpia el intervalo cuando el componente se destruye
    clearInterval(this.intervalId);
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    formattedTime() {
      const minutes = Math.floor(this.timerCount / 60);
      const seconds = this.timerCount % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
        this.updateHeaders();
      }
    },
    "editableData.sProvider": function (newValue) {
      this.showCreateProvider = newValue === 0;
    },
  },
};

</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
  color: yellow !important;
  background-color: yellow !important;
}

.active-section .v-list-item__title {
  background-color: yellow !important;
} */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #193D6E !important;
  height: 3px;
  color: #193D6E !important;
  border-radius: 100px;
}

.card-main {
  width: 40vh;
  height: 16vh;
  position: relative;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
}

.card-content {
  position: absolute;
  top: 19px;
  left: 16px;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #193D6E;
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #193D6E;
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}
.selected-card {
  border: 2px solid #0075B8 !important;
}
.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #193D6E;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.test {
  border-radius: 100px !important;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}
</style>
